// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

import { collection, getFirestore, limit, query, where, getDocs, doc, updateDoc } from 'firebase/firestore';


// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyDCWh18W_165ukcyYPxlPLSgOzHnL4hgyk",
    authDomain: "atharvalab-prod.firebaseapp.com",
    databaseURL: "https://atharvalab-prod-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "atharvalab-prod",
    storageBucket: "atharvalab-prod.firebasestorage.app",
    messagingSenderId: "369503950794",
    appId: "1:369503950794:web:f8622e9dcef0820218e133",
    measurementId: "G-T9V2S6E3PR"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const db = getFirestore(app);

export const getHologramByEncodedId = async (encodedId) => {
    try {
        const q = query(
            collection(db, 'holograms'),
            where('encodedIdString', '==', encodedId),
            limit(1) // Limit the query to return only one document
        );
        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty) { // Check if any documents were found
            const doc = querySnapshot.docs[0]; // Get the first document
            return {
                id: doc.id,
                data: doc.data()
            };
        } else return null;
    } catch (err) {
        return null;
    }
};

export const updateHologramRegistered = async (hologramDocumentId, newValue) => {
    try {
        const hologramDocRef = doc(db, 'holograms', hologramDocumentId);
        await updateDoc(hologramDocRef, {
            hologramRegistered: newValue,
        });
        return true;
    } catch (err) {
        return false;
    }
};
